import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface YelpSectionProps {
  asset: DigitalAsset;
  canViewProfileUrl: boolean;
  canViewDescription: boolean;
}

const YelpSection = ({
  asset,
  canViewProfileUrl,
  canViewDescription,
}: YelpSectionProps) => {
  if (!canViewProfileUrl && !canViewDescription) return null;

  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div className="bg-white rounded-lg box-shadow">
          <Disclosure.Button className="disclosureBtn ml-2">
            <ChevronRight
              className={`${
                open ? "transform rotate-90" : " text-gray-500"
              } text-gray-500 w-5 h-5 `}
            />
            <span className="disclosureLabel ml-2">Yelp</span>
          </Disclosure.Button>

          <Disclosure.Panel className="text-xs">
            <div className="grid grid-cols-2 text-xs">
              {canViewProfileUrl && (
                <div className="p-2">
                  <div className="grid grid-cols-1 py-2 px-2 space-y-2">
                    <label className="mx-4 expandedLabel fontExpand">
                      Yelp Profile URL:
                    </label>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-4 expandedData fontExpand text-blue-500 underline break-all"
                      href={
                        asset.yelp_Profile_Url__C &&
                        asset.yelp_Profile_Url__C !== "NULL"
                          ? asset.yelp_Profile_Url__C
                          : ""
                      }
                    >
                      {asset.yelp_Profile_Url__C !== "NULL"
                        ? asset.yelp_Profile_Url__C
                        : ""}
                    </a>
                  </div>
                </div>
              )}

              {canViewDescription && (
                <div className="p-2">
                  <div className="grid grid-cols-1 py-2 px-2 space-y-2">
                    <label className="mx-4 expandedLabel fontExpand">
                      Yelp Description (Specialties):
                    </label>
                    <div className="mx-4 expandedData fontExpand">
                      {asset.yelp_Description_Specialties__C !== "NULL"
                        ? asset.yelp_Description_Specialties__C
                        : ""}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

export default YelpSection;